import { SvgIcon } from "@mui/material";

export const SoundWave = (props) => {
  return (
    <SvgIcon {...props} viewBox="9 34.5 74 31" sx={{ ...props.sx, fill: "none" }}>
      <defs>
        <linearGradient id="wave-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#9cb700" />
          <stop offset="100%" stopColor="#b1b300" />
        </linearGradient>

        <mask id="wave-mask">
          <line x1="10" y1="50" x2="10" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="46;41;35;41;46" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="54;59;65;59;54" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="14.5" y1="50" x2="14.5" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="44;38;44;41;44" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="56;62;56;59;56" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="19" y1="50" x2="19" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="41;46;41;35;41" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="59;54;59;65;59" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="23.5" y1="50" x2="23.5" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="38;44;46;44;38" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="62;56;54;56;62" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="28" y1="50" x2="28" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="35;38;41;44;35" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="65;62;59;56;65" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="32.5" y1="50" x2="32.5" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="46;38;41;35;46" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="54;62;59;65;54" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="37" y1="50" x2="37" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="41;44;35;46;41" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="59;56;65;54;59" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="41.5" y1="50" x2="41.5" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="38;41;46;41;38" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="62;59;54;59;62" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="46" y1="50" x2="46" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="44;35;38;41;44" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="56;65;62;59;56" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="50.5" y1="50" x2="50.5" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="35;46;44;38;35" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="65;54;56;62;65" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="55" y1="50" x2="55" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="41;35;41;46;41" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="59;65;59;54;59" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="59.5" y1="50" x2="59.5" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="38;44;41;44;38" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="62;56;59;56;62" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="64" y1="50" x2="64" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="46;41;35;41;46" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="54;59;65;59;54" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="68.5" y1="50" x2="68.5" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="44;46;44;38;44" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="56;54;56;62;56" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="73" y1="50" x2="73" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="38;41;44;35;38" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="62;59;56;65;62" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="77.5" y1="50" x2="77.5" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="38;41;35;44;38" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="62;59;65;56;62" dur="2s" repeatCount="indefinite" />
          </line>

          <line x1="82" y1="50" x2="82" y2="50" stroke="white" strokeWidth="2" strokeLinecap="round">
            <animate attributeName="y1" values="44;35;46;38;44" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="56;65;54;62;56" dur="2s" repeatCount="indefinite" />
          </line>
        </mask>
      </defs>

      <rect x="9" y="34.5" width="74" height="31" fill="url(#wave-gradient)" mask="url(#wave-mask)" />
    </SvgIcon>
  );
};
